import {ReportedTimeModel} from './reported-time.model';

export class WorkTimeRangeModel {
  id: number;
  startTime: number;
  stopTime: number;
  status: string;
  reportedTimes: ReportedTimeModel[];
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-model/work-time-range.model.ts